export default {options:{version:1},children:[{options:{key:'timestamp',type:'value'}}]}